import ics from "ical.js";

export function install(Vue) {
  Vue.prototype.$ical = ics;
}

export default {
  install
};
